import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import "core-js/modules/es.number.constructor.js";
/* eslint-disable sonarjs/no-identical-expressions */
/* eslint-disable no-self-compare */
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Utility class for retrieving environment variables and with a fallback default
 */
var EnvUtils = /*#__PURE__*/_createClass(function EnvUtils() {
  _classCallCheck(this, EnvUtils);
});
/**
 * Retrieve a property value from `process.env` object.
 *
 * If this property doesn't exist, it will return a given default value, or false if defined.
 *
 * @param {string} envProp environment property key value
 * @param {*} defaultValue The value to return if property is not set in environment
 * @param {function} callback A function to perform on the returned property value. This callback must return the result.
 * This function is statically called using `EnvUtils.getEnvironmentProperty( .. )`
 */
_defineProperty(EnvUtils, "getEnvironmentProperty", function (envProp) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var prop = process.env[envProp];
  if (prop) {
    var propValue = process.env[envProp];
    /*
     * we are doing this craziness because the best way to check whether a value is NaN is to check whether it is equal to itself
     * NaN is funnily not equal to itself
     * while ECMAScript 6 brought in the global function isNaN(..)
     * see http://adripofjavascript.com/blog/drips/the-problem-with-testing-for-nan-in-javascript.html for more information
     *
     * this is the reason we are disabling some linting rules at file level (as there are 2)
     */
    var propValueAsNumber = Number(propValue);
    if (propValueAsNumber === propValueAsNumber) {
      // this property is a number
      return callback ? callback(propValueAsNumber) : propValueAsNumber;
    }
    if (propValue === 'true' || propValue === 'false') {
      // this property is a boolean
      return callback ? callback(propValue) : propValue === 'true';
    }

    // likely this is just a string
    return callback ? callback(propValue) : propValue;
  }
  return defaultValue;
});
export { EnvUtils as default };